import { LoadingSpinner } from "@/core/components/loading-spinner";
import LogoIcon from "@/core/components/logo-icon";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { InitiateVerificationResponse } from "@/payouts/payouts";

interface CreditClaimedProps {
  verificationData: InitiateVerificationResponse;
  isProcessing?: boolean;
}

export const CreditClaimed = ({
  verificationData,
  isProcessing = false,
}: CreditClaimedProps) => (
  <Stack
    align="center"
    fullWidth
    className="m-auto min-h-screen max-w-md bg-card p-8"
    gap="xl"
  >
    <LogoIcon />
    <Typography variant="subtitleW1">
      {isProcessing
        ? "Processing your credit payment"
        : "Credit Payment Successful"}
    </Typography>
    {isProcessing && <LoadingSpinner />}
    <Typography variant="bodyW1" className="text-center text-[#637381]">
      {isProcessing
        ? `Your credit is being added to your account. You will have access to it when you book a service at ${verificationData?.business_name}.`
        : `Your credit has been successfully added to your account. It will be available when you book a service at ${verificationData?.business_name}.`}
    </Typography>
  </Stack>
);
